import { useState, useEffect, useCallback } from 'react';
import { SetupWSEventListener } from '../utils/setupWSEventListener';
import { localizedErrorMessage } from '../utils/italianErrorMessage';

export default function useDashboardStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStats = useCallback(async () => {
    try {
      const res = await fetch(`/api/stats/dashboard?t=${Date.now()}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'x-tenant-id': `${localStorage.getItem('tenantId')}`
        }
      });

      if (!res.ok) throw new Error('Errore nel recupero dati');

      const data = await res.json();
      setStats(data);
    } catch (err) {
      setError(localizedErrorMessage(err, 'Errore nel recupero dei dati.'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();

    const cleanup = SetupWSEventListener(fetchStats);
    return cleanup;
  }, [fetchStats]);

  return { stats, loading, error };
}
